<template>
    <card-expandable
        v-if="props.chat.contactData"
        toggle-color="gray-100"
        is-opened-at-start
        with-collapse-arrow
        with-content
    >
        <text-decorator :size="Size.xs">
            Persoonsgegevens
        </text-decorator>

        <template #content>
            <flex-container direction="column" :gap="Size.sm">
                <flex-container
                    v-if="props.chat.contactData.name"
                    direction="column"
                    :gap="Size.xs"
                >
                    <text-decorator
                        :size="FontSize.xs"
                        color="gray-800"
                        bold
                    >
                        Naam
                    </text-decorator>
                    <text-decorator
                        :size="FontSize.xs"
                        color="gray-800"
                    >
                        {{ props.chat.contactData.name }}
                    </text-decorator>
                </flex-container>
                <flex-container
                    v-if="props.chat.contactData.email"
                    direction="column"
                    :gap="Size.xs"
                >
                    <text-decorator
                        :size="FontSize.xs"
                        color="gray-800"
                        bold
                    >
                        E-mail
                    </text-decorator>
                    <copy-decorator :value="props.chat.contactData.email">
                        <text-decorator
                            :size="FontSize.xs"
                            color="gray-800"
                        >
                            {{ props.chat.contactData.email }}
                        </text-decorator>
                    </copy-decorator>
                </flex-container>
                <flex-container
                    v-if="props.chat.contactData.phoneNumber"
                    direction="column"
                    :gap="Size.xs"
                >
                    <text-decorator
                        :size="FontSize.xs"
                        color="gray-800"
                        bold
                    >
                        Telefoonnummer
                    </text-decorator>
                    <copy-decorator :value="props.chat.contactData.phoneNumber">
                        <text-decorator
                            :size="FontSize.xs"
                            color="gray-800"
                        >
                            {{ props.chat.contactData.phoneNumber }}
                        </text-decorator>
                    </copy-decorator>
                </flex-container>
                <flex-container
                    v-if="props.chat.contactData.postalCode"
                    direction="column"
                    :gap="Size.xs"
                >
                    <text-decorator
                        :size="FontSize.xs"
                        color="gray-800"
                        bold
                    >
                        Postcode
                    </text-decorator>
                    <text-decorator
                        :size="FontSize.xs"
                        color="gray-800"
                    >
                        {{ props.chat.contactData.postalCode }}
                    </text-decorator>
                </flex-container>
                <flex-container
                    v-if="props.chat.contactData.houseNumber"
                    direction="column"
                    :gap="Size.xs"
                >
                    <text-decorator
                        :size="FontSize.xs"
                        color="gray-800"
                        bold
                    >
                        Huisnummer
                    </text-decorator>
                    <text-decorator
                        :size="FontSize.xs"
                        color="gray-800"
                    >
                        {{ props.chat.contactData.houseNumber }}
                    </text-decorator>
                </flex-container>
            </flex-container>
        </template>
    </card-expandable>
</template>

<script setup lang="ts">
    import { FontSize, Size } from '@keyvue/one-ui';
    import type { Chat } from '@keyvue/one-api-client';
    import CopyDecorator from '@/shared/components/CopyDecorator.vue';

    const props = defineProps<{ chat: Chat }>();
</script>
